import withStyles from '@material-ui/core/styles/withStyles';
import {
  InputAdornment,
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import Check from '@material-ui/icons/Check';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import MotorcycleIcon from '@material-ui/icons/TwoWheeler';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import CustomTextarea from 'components/CustomTextarea/CustomTextarea';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import WaitDialog from 'conten/components/WaitDialog.jsx';
import AplicarSeguridad from 'conten/components/AplicarSeguridad';
import { connect } from 'react-redux';
import { guardarPlaca } from './PlacasActions';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx';
import { addMessage } from 'conten/mensajes/MessagesActions';
import React from 'react';

class PlacaAdministrar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textoAlerta: 'Un momento por favor ...',
      placa: {
        placa: '',
        propietario: localStorage.getItem('numeroDocumentoUsuario') || '',
        creador: localStorage.getItem('ID_USUARIO') || '',
        informacion: '',
        activo: true,
      },
    };
  }

  componentDidMount = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    if (
      urlParams.get('editar') === 'true' &&
      this.props.location.state?.placa
    ) {
      this.setState({ placa: this.props.location.state.placa });
    }
  };

  cambioContenidoPlaca = (valor, campo) => {
    this.setState((prevState) => ({
      placa: {
        ...prevState.placa,
        [campo]: valor,
      },
    }));
  };

  validarFormatoPlaca = () => {
    const regexAuto = /^[A-Z]{3}[0-9]{3}$/;
    const regexMoto1 = /^[A-Z]{3}[0-9]{2}[A-Z]$/;
    const regexMoto2 = /^[A-Z]{3}[0-9]{2}$/;

    const { placa } = this.state.placa;
    if (regexAuto.test(placa)) {
      return { tipo: 'Automóvil', icono: <DirectionsCar /> };
    } else if (regexMoto1.test(placa) || regexMoto2.test(placa)) {
      return { tipo: 'Motocicleta', icono: <MotorcycleIcon /> };
    }
    throw new Error('Formato de placa no válido.');
  };

  validarContenidos = () => {

    const { placa } = this.state;

    // Validar la placa
    if (!placa.placa || placa.placa.trim() === "") {
      throw new Error("La placa es obligatoria.");
    }

    // Validar la placa
    if (!placa.propietario || String(placa.propietario).trim() === "") {
      throw new Error("El documento del propietario es obligatorio.");
    }

    // Si pasa todas las validaciones, no hace nada (o puedes devolver un true)
    return true;

  };

  guardarCambios = () => {
    try {
      this.validarContenidos();
      this.props.guardarPlaca(this.state.placa, (resultado) => {
        if (resultado === 'OK') {
          this.props.history.goBack();
        }
      });
    } catch (error) {
      this.abrirAlerta(error.message);
    }
  };

  abrirAlerta = (texto, tipo = 'error') => {
    this.props.addMessage({ variant: tipo, message: texto });

  };

  render() {
    const { placa } = this.state;
    return (
      <GridItem xs={12}>
        {this.props.isActivityIndicatorShown && (
          <WaitDialog text={this.state.textoAlerta} />
        )}
        <AplicarSeguridad />
        <Card style={{ marginTop: '45px' }}>
          <CardHeader icon>
            <CardIcon
              color='primary'
              onClick={() => this.props.history.goBack()}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', height: '40px' }}
            >

              <DirectionsCar style={{ padding: '0px', margin: '0px', marginRight: '5px' }} />
              <b>{'Ver listado'}</b>
            </CardIcon>
            {/* <TituloPagina2
              texto='Datos de vehículo'
              color='primary'
              classes={classes}
            /> */}
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText='* Placa'
                  id='placa'
                  success
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: placa.placa,
                    onChange: (e) =>
                      this.cambioContenidoPlaca(
                        e.target.value.toUpperCase(),
                        'placa'
                      ),
                    endAdornment: (
                      <InputAdornment position='start'></InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText='* Propietario'
                  id='propietario'
                  success
                  disabled={true}
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: placa.propietario,
                    onChange: (e) =>
                      this.cambioContenidoPlaca(
                        e.target.value,
                        'propietario'
                      ),
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <CustomTextarea
                  labelText='Información'
                  id='informacion'
                  success
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: placa.informacion,
                    onChange: (e) =>
                      this.cambioContenidoPlaca(
                        e.target.value,
                        'informacion'
                      ),
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <Button
                  type='button'
                  onClick={this.guardarCambios}
                  color='success'
                >
                  <SaveIcon />
                  Guardar
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const mapStateToProps = (state) => ({
  PlacaState: state.PlacaState,
});

// const mapDispatchToProps = (dispatch) => ({
//   guardarPlaca: (placa, onSuccess) => dispatch(guardarPlaca(placa, onSuccess)),
//   addMessage: (content) => dispatch(addMessage(content)),
// });
const mapDispatchToProps = (dispatch) => {
  return {
    guardarPlaca: (placa, onSuccess) => (
      dispatch(guardarPlaca(placa, onSuccess))),
    addMessage: (content) => dispatch(addMessage(content)),
  };
};

export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlacaAdministrar)
);
